const $header = $('.masthead'),
    $footer = $('.site-footer'),
    $button = $('.scroll-to-top__button'),
    classButtonVisible = 'scroll-to-top__button--visible';

$(window).on('scroll', function () {
    let scrolledDistance = $(document).scrollTop(),
        showTrigger = viewport().height / 2,
        hideTrigger = $(document).outerHeight() - ($footer.outerHeight() / 2) - viewport().height;

    if (scrolledDistance > showTrigger && scrolledDistance < hideTrigger) {

        if (!$button.hasClass(classButtonVisible)) {
            $button.addClass(classButtonVisible);
        }

    } else {
        if ($button.hasClass(classButtonVisible)) {
            $button.removeClass(classButtonVisible);
        }
    }
});

$button.on('click', function (e) {
    e.preventDefault();

    $('html, body').stop().animate({
        scrollTop: 0
    }, 1000, 'easeInOutCubic');
});